import { MenuItem as MuiMenuItem } from "@mui/material";
import React, { MouseEvent } from "react";
import { FCWithChildren, WithTesting } from "../../types";

export type MenuItemProps = WithTesting & {
  selected?: boolean;
  disabled?: boolean;
  onClick?: (e: MouseEvent) => void;
  className?: string;
  value?: string;
};

export const MenuItem: FCWithChildren<MenuItemProps> = (props) => {
  const { children, selected, disabled, dataTestId, onClick, className } =
    props;

  return (
    <MuiMenuItem
      selected={selected}
      disabled={disabled}
      data-testid={dataTestId}
      onClick={onClick}
      className={className}
    >
      {children}
    </MuiMenuItem>
  );
};
